import { ACCOMMODATION_TYPES } from '@src/shared/src/const/app';
import { formatDate } from '@src/shared/src/util/date';
import { Trans, useTranslation } from 'react-i18next';
import * as React from 'react';
import '../styles/HotelFareRefundableUntil.scss';

type Props = {
  refundableUntil: Date;
  conditions: string;
  accommodationType: ACCOMMODATION_TYPES;
  deepLink: string;
};

export const HotelFareRefundableUntil: React.FC<Props> = ({
  refundableUntil,
  conditions,
  accommodationType,
  deepLink,
}) => {
  const { t } = useTranslation();
  if (refundableUntil) {
    return (
      <span data-rh={conditions} data-rh-at="left">
        <i className="material-symbols is--green">check_circle</i>
        {`${t('hotelFare.tbody.until')} ${formatDate(refundableUntil)}`}
      </span>
    );
  }

  if (accommodationType === ACCOMMODATION_TYPES.VACATION_RENTAL) {
    return (
      <div className="hotel-fare-refundable-until-note">
        <Trans i18nKey="hotelFareRefundableUntil.airbnbConditions">
          <a href={deepLink} target="_blank">
            aribnDeeplink
          </a>
        </Trans>
      </div>
    );
  }

  return (
    <span>
      <i className="material-symbols is--red">cancel</i>
      {t('hotelFare.tbody.notCancellable')}
    </span>
  );
};
